const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
const isStandalone = !!(iOS && window.navigator.standalone);

export default (theme) => ({
  dialogRoot: {
    [theme.breakpoints.up('sm')]: {
      // width: 620,
      maxWidth: '100%',
    },
    [theme.breakpoints.down('sm')]: {
      margin: 5,
    },
  },
  mainCropperWrapper: {
    width: 600,
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  title: {
    fontSize: 24,
    fontWeight: 500,
    padding: '15px 24px 5px',
  },
  cropperTitle: {
    margin: '10px 0',
  },
  content: {
    color: theme.palette.textColor.dark,
    fontSize: 14,
    fontWeight: 500,
    padding: '5px 0',
  },
  closeButton: {
    position: 'absolute',
    top: '5px',
    right: '5px',
  },
  button: {
    color: theme.palette.primary.blue,
    border: theme.palette.primary.blue,
    background: '#fff',
    '&:hover': {
      color: '#fff',
      background: '#1976D2! important',
    },
    '&:focus': {
      color: '#fff',
      background: `${theme.palette.primary.blue} !important`,
    },
  },
  radio: {
    flexWrap: 'nowrap',
    justifyContent: 'flex-start',
    alignItems: 'center',
    '& label': {
      alignItems: 'center',
      justifyContent: 'center',
      '& span': {
        fontSize: 16,
        fontWeight: 400,
      },
    },
  },
  buttonHolder: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  cancelButton: {
    margin: 10,
    minWidth: 140,
    padding: '7px 0px',
    '&:hover': {
      color: theme.palette.textColor.dark,
    },
    '&:focus': {
      color: theme.palette.textColor.dark,
      backgroundColor: '#fff',
    },
    '&:disabled': {
      backgroundColor: '#fff',
    },
  },
  saveButton: {
    margin: 10,
    minWidth: 140,
    padding: '7px 0px',
    '&:hover': {
      color: theme.palette.textColor.primary,
    },
    '&:focus': {
      color: theme.palette.textColor.primary,
      backgroundColor: '#fff',
    },
    '&:disabled': {
      backgroundColor: '#fff',
    },
  },
  resultImgWrapper: {
    display: 'flex',
    gap: 15,
  },
  positionerWrapper: {
    position: 'relative',
  },
  imgWrapper: {
    // width: '120px',
    // height: '80px',
    // borderRadius: '3px',
    // overflow: 'hidden',
    // marginBottom: 8,

    '& img': {
      objectFit: 'cover',
      width: '100%',
      height: '100%',
    },
  },
});
